export const PRODUCTION_RESULTS = [
  {
    id: 'fragrance',
    client: 'Maison Fragrance House',
    sector: 'Luxury',
    headline: 'A fragrance launch produced in 3 weeks, not 3 months',
    summary: 'A full campaign suite — hero film, stills and 40+ social cutdowns — shot and finished by our production division across four markets.',
    kpis: [
      { label: 'Campaign Reach', value: 18.2, suffix: 'M', decimals: 1 },
      { label: 'ROAS', value: 6.4, suffix: 'x', decimals: 1 },
      { label: 'Faster to Market', value: 74, suffix: '%' },
    ],
  },
  {
    id: 'auto',
    client: 'Performance Coupe Reveal',
    sector: 'Automotive',
    headline: 'Night-shoot reveal that filled the order book',
    summary: 'Cinematic launch assets and creator placements built around a single reveal weekend, driving pre-orders across the UK and DACH.',
    kpis: [
      { label: 'Pre-orders Influenced', value: 1240, suffix: '+' },
      { label: 'Cost per Lead', value: 61, prefix: '−', suffix: '%' },
      { label: 'Video Completion', value: 48, suffix: '%' },
    ],
  },
  {
    id: 'beauty',
    client: 'DTC Skincare Group',
    sector: 'Beauty',
    headline: 'Monthly creative engine for profitable scale',
    summary: 'A rolling production cadence of 120 assets a month, retiring fatigued creative before performance ever dipped.',
    kpis: [
      { label: 'Revenue Growth', value: 212, suffix: '%' },
      { label: 'Assets per Month', value: 120 },
      { label: 'CPA Reduction', value: 43, suffix: '%' },
    ],
  },
];